<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Mehinaku</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<h2 class="head02" id="fm_2"><a id="page_xi"></a><a href="#/xhtml/Contents#fm2">Tables</a></h2>
<p class="hang" id="tab1"><span href="#/xhtml/Chapter4#t_1" title="Link target outside of Sample">  1. Whoops that signal social and natural events</span></p>
<p class="hang" id="tab2"><span href="#/xhtml/Chapter5#t_2" title="Link target outside of Sample">  2. Categories of speech</span></p>
<p class="hang" id="tab3"><span href="#/xhtml/Chapter8#t_3" title="Link target outside of Sample">  3. Differences between possessed and unpossessed forms of Mehinaku</span></p>
<p class="hang" id="tab4"><span href="#/xhtml/Chapter9#t_4" title="Link target outside of Sample">  4. Mehinaku extramarital affairs, 1972</span></p>
<p class="hang" id="tab5"><span href="#/xhtml/Chapter10#t_5" title="Link target outside of Sample">  5. Everyday Mehinaku adornment</span></p>
<p class="hang" id="tab6"><span href="#/xhtml/Chapter10#t_6" title="Link target outside of Sample">  6. Everyday oils, pigments, and designs</span></p>
<p class="hang" id="tab7"><span href="#/xhtml/Chapter10#t_7" title="Link target outside of Sample">  7. The meaning of Mehinaku adornment</span></p>
<p class="hang" id="tab8"><span href="#/xhtml/Chapter11#t_8" title="Link target outside of Sample">  8. Terms used in greeting kinsmen and in-laws</span></p>
<p class="hang" id="tab9"><span href="#/xhtml/Chapter11#t_9" title="Link target outside of Sample">  9. The meaning of Mehinaku greetings</span></p>
<p class="hang" id="tab10"><span href="#/xhtml/Chapter12#t_10" title="Link target outside of Sample">10. Inventory of the possessions of one of the wealthiest villagers</span></p>
<p class="hang" id="tab11"><span href="#/xhtml/Chapter12#t_11" title="Link target outside of Sample">11. Age and craft skills</span></p>
<p class="hang" id="tab12"><span href="#/xhtml/Chapter12#t_12" title="Link target outside of Sample">12. Height and social participation of the adult Mehinaku men</span></p>
<p class="hang" id="tab13"><span href="#/xhtml/Chapter12#t_13" title="Link target outside of Sample">13. Witches and some of their methods</span></p>
<p class="hang" id="tab14"><span href="#/xhtml/Chapter12#t_14" title="Link target outside of Sample">14. Accusations of witchcraft by thirteen Mehinaku adults</span></p>
<p class="hang" id="tab15"><span href="#/xhtml/Chapter14#t_15" title="Link target outside of Sample">15. Periods of seclusion</span></p>
<p class="hang" id="tab16"><span href="#/xhtml/Chapter14#t_16" title="Link target outside of Sample">16. Activities in seclusion</span></p>
<p class="hang" id="tab17"><span href="#/xhtml/Chapter14#t_17" title="Link target outside of Sample">17. Symbols of seclusion</span></p>
<p class="hang" id="tab18"><span href="#/xhtml/Chapter14#t_18" title="Link target outside of Sample">18. Classes of food relevant to seclusion taboos</span></p>
<p class="hang" id="tab19"><span href="#/xhtml/Chapter14#t_19" title="Link target outside of Sample">19. The prohibition of fish, monkey, and bird meat in seclusion</span></p>
<p class="hang" id="tab20"><span href="#/xhtml/Chapter16#t_20" title="Link target outside of Sample">20. A continuum of possible relationships between kinsmen and nonkinsmen</span></p>
<p class="hang"></p>
<p class="hang" id="tab21"><a id="page_xii"></a><span href="#/xhtml/Chapter16#t_21" title="Link target outside of Sample">21. The depth and scope of Mehinaku kindreds</span></p>
<p class="hang" id="tab22"><span href="#/xhtml/Chapter16#t_22" title="Link target outside of Sample">22. Restrictions honored by fathers during their infants’ first year</span></p>
<p class="hang" id="tab23"><span href="#/xhtml/Chapter16#t_23" title="Link target outside of Sample">23. Circumlocutions used to avoid the names of affinal relatives</span></p>
<p class="hang" id="tab24"><span href="#/xhtml/Chapter18#t_24" title="Link target outside of Sample">24. Xingu trade specialties and monopolies</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter02.vue?068b65e0